module.exports = __webpack_public_path__ + "static/media/wallet.2b018130.svg";